export default function MostChosen({ className = '' }: { className?: string }) {
  return (
    <div className={`absolute right-0 bg-young-fern text-white p-3 ${className}`}>
      <span className="font-bold">Meestgekozen!</span>
    </div>
  )
}
